export * from './template-modal.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/template-modal/index.ts